(() => {
  function init(root) {
    if (!root || root.__inkdHeroBound) return;
    root.__inkdHeroBound = true;

    const bar = root.querySelector('[data-role="bar"]');
    const input = root.querySelector('[data-role="input"]');
    const chips = root.querySelectorAll('[data-chip]');

    if (!bar || !input) return;

    const setActive = (on) => bar.classList.toggle("is-active", !!on);

    input.addEventListener("focus", () => setActive(true));
    input.addEventListener("blur", () => setActive(false));
    input.addEventListener("input", () => setActive(true));

    chips.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const val = btn.getAttribute("data-chip") || "";
        input.value = val;
        input.focus();
        setActive(true);
        const form = input.closest("form");
        if (form) form.requestSubmit();
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".inkd-aihero").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();






